import { render, staticRenderFns } from "./ReportReceiverPayOnDesBranch.vue?vue&type=template&id=170e6568&"
import script from "./ReportReceiverPayOnDesBranch.vue?vue&type=script&lang=js&"
export * from "./ReportReceiverPayOnDesBranch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports